import { DayOfWeek, Instant, LocalDateTime, LocalTime, ZoneId } from "@js-joda/core";
import { globalize } from "./translate";

export function formatTimestamp(value: Instant): string {
  const valueLocal = LocalDateTime.ofInstant(value, ZoneId.SYSTEM);
  const now = LocalDateTime.ofInstant(Instant.now(), ZoneId.SYSTEM);

  if (valueLocal.toLocalDate().equals(now.toLocalDate())) {
    return globalize().formatInstant(value, { time: "short" });
  } else {
    return globalize().formatInstant(value, { skeleton: "MMMd" });
  }
}

export function hoursToDisplayTime(hours: number): string {
  return globalize().formatLocalDateTime(LocalDateTime.of(2000, 1, 1, hours % 24, 0), {
    skeleton: "h",
  });
}

export function minutesToDisplayTime(minutes: number): string {
  return globalize().formatLocalTime(minutesToLocalTime(minutes), { time: "short" });
}

export function minutesToDisplayTimeForDecimalTime(minutes: number): string {
  const minutesAsNumber = minutes % 60;
  let hour = Math.floor(minutes / 60);

  if (hour === 24) {
    hour = 0;
  }

  return globalize().formatLocalTime(LocalTime.of(hour, minutesAsNumber), {
    time: "short",
  });
}

export function getMinutesFromLocalTime(time: LocalTime) {
  return time.hour() * 60 + time.minute();
}

export function minutesToLocalTime(minutes: number): LocalTime {
  return LocalTime.of(Math.floor((minutes / 60) % 24), minutes % 60);
}

export function decimalHourToDisplay(
  hoursFraction: number,
  form: "long" | "short" | "narrow" = "short"
) {
  let returnString = "";
  const hours = Math.floor(Math.round(hoursFraction * 100) / 100);
  if (hours > 0) {
    returnString += globalize().formatUnit(hours, "hour", { form: form });
  }

  const minutes = ((Math.round(hoursFraction * 100) % 100) / 100) * 60;
  if (minutes > 0) {
    if (hours > 0) {
      returnString += " ";
    }
    returnString += globalize().formatUnit(minutes, "minute", { form: form });
  }

  return returnString;
}

/**
 * The day numbering system used in DayTimeParams
 *
 * 0 -> SUNDAY
 * 1 -> MONDAY
 * 2 -> TUESDAY
 * 3 -> WEDNESDAY
 * 4 -> THURSDAY
 * 5 -> FRIDAY
 * 6 -> SATURDAY
 */
export function dayOfWeekFromNumber(day: number): DayOfWeek {
  return DayOfWeek.of(((day + 6) % 7) + 1);
}
